export default __webpack_public_path__ + "static/media/potatoes.e41c72ed.png";